import styled from 'styled-components'
import { colors } from '../../theme'

export const Span = styled.button`
  position: absolute;
  top: 24px;
  right: 10px;
  border: none;
  background-color: transparent;
  cursor: pointer;
`

export const InputStyle = styled.input<{
  border: string
  sizeY: string
  sizeX: string
}>`
  outline: none;
  border: 1px solid ${colors.grey300};
  border-radius: 10px;
  margin-top: 20px; //retirar
  margin-bottom: 15px;
  font-size: 13px;
  padding: 15px;
  padding-right: 55px;

  border: 1.5px solid ${({ border }) => border};
  border-radius: 12px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 12px;
  margin-top: 15px;
`

export const DivInput = styled.div`
  padding: 20px 20px 0px 20px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  margin-bottom: 20px;
  position: relative;
  background-color: ${colors.surface};
`

export const ContainerInput = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DivColapse = styled.div<{ alinhamento?: boolean }>`
  display: flex;
  align-items: ${({ alinhamento }) => `${alinhamento ? 'center' : 'start'}`};
  justify-content: space-between;
  padding-right: 10px;
  width: 100%;
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: left;
  gap: 15px;
  align-items: center;
`

export const TypesFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-size: 12px;
  height: 42px;
  background: ${colors.grey200};
  border-radius: 8px;
  cursor: pointer;
`
export const TypesFilterCalendar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  font-size: 12px;
  height: 42px;
  background: ${colors.grey200};
  border-radius: 8px;
  cursor: pointer;
  width: 380px;
`
export const Filters = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: none;
  border: none;
  height: 100%;
  width: 100%;
  cursor: pointer;
`
export const ButtonColapse = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const FiltersCalendar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  width: 100%;
`

export const SearchCompanies = styled.input`
  border: none;
  width: 100%;
  padding-left: 10px;
`

export const FilterCompanie = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 120px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 500px;
  z-index: 10;
`

export const FilterClient = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 345px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 500px;
  z-index: 10;
`

export const FilterProduct = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 480px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 500px;
  z-index: 10;
`

export const FilterSalesPeople = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 220px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 500px;
  z-index: 10;
`

export const FilterDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 550px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 20px;
  width: 680px;
  z-index: 10;
  @media screen and (max-width: 1400px) {
    left: 420px;
  }
`
export const Calendars = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 20px;
  font-size: 20px;
`
export const OptionActive = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
`

export const Option = styled.div`
  height: 30px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colors.grey900};
  font-weight: 500;
  font-size: 12px;
  line-height: 2em;
  text-align: left;
  margin-right: 15px;
  margin-top: 5px;
  border-radius: 4px;
  background-color: ${colors.grey50};
  border: solid 1px ${colors.grey200};
  box-shadow: 7px 5px 7px rgba(0, 0, 0, 0.28);
`

export const Filtro = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const DatePickerStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  gap: 10px;
  margin-left: 5px;
`
